// ignore-string-externalization

import type { GetBlogPostsQuery } from '../../graphql/generated';

export const BLOG_QUERY = /* GraphQL */ `
  query GetBlogPosts(
    $limit: Int!
    $skip: Int!
    $locale: String!
    $now: DateTime!
  ) {
    articlePageCollection(
      limit: $limit
      skip: $skip
      locale: $locale
      order: releaseDate_DESC
      where: {
        releaseDate_lte: $now
        requiredFeatureFlag_not: "s4a-frodor-test"
      }
    ) {
      total
      items {
        sys {
          id
        }
        title
        urlSlug
        introduction
        article
        description
        releaseDate
        languages
        headerModule {
          image {
            url
            title
            description
            width
            height
          }
        }
      }
    }
  }
`;

export const HEROES_QUERY = /* GraphQL */ `
  query GetHeroes($locale: String!) {
    headerImageCollection(locale: $locale) {
      items {
        artistId
        artistName
        bannerImage {
          url
        }
      }
    }
  }
`;

export type BlogItem = NonNullable<
  NonNullable<GetBlogPostsQuery['articlePageCollection']>['items'][number]
>;
